import { render, staticRenderFns } from "./ActivateFooter.vue?vue&type=template&id=8e3358ce&scoped=true"
import script from "./ActivateFooter.vue?vue&type=script&lang=js"
export * from "./ActivateFooter.vue?vue&type=script&lang=js"
import style0 from "./ActivateFooter.vue?vue&type=style&index=0&id=8e3358ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3358ce",
  null
  
)

export default component.exports